import React, { useState, useEffect } from 'react';
import { Widget, GridView, SimpleView, usePromise } from '@digital/ui';
import FiltroDashboard from './FiltroDashboard';
import { Filter, DashboardData, getDashboardData } from './@app/../../../api/dashboardContratos';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import '../Contrato/custom.css';
import DashboardContratoTabelaContratosVigentes from './DashboardContratoTabelaContratosVigentes';

const DashboardContratos = () => {
    const [data, setData] = useState({} as DashboardData);

    const [initialValue] = usePromise<DashboardData>(getDashboardData, [], {} as DashboardData);

    useEffect(() => {
        setData(initialValue);
    }, [initialValue]);


    Highcharts.setOptions({
        lang: {
            thousandsSep: '.',
            decimalPoint: ',',
            numericSymbols: [' k', ' M', ' B', ' T', 'P', 'E'],
        },
    });
    const optionsDiretoria: Highcharts.Options = {
        chart: { type: 'column' },
        legend: { enabled: false },
        yAxis: { min: 0, title: { text: '' } },
        tooltip: { pointFormat: '<b>R$ {point.y:,.2f}</b>' },
        colors: [
            '#fc8e5b',
            '#a6ba59',
            '#d8483d',
            '#906380',
            '#e9c382',
            '#39a693',
            '#37889b',
            '#9f8141',
            '#7a9970',
            '#fc5856',
        ],
        xAxis: {
            tickInterval: 0,
            labels: {
                enabled: true,
                formatter: function () {
                    return data.diretorias.map((a: any) => [a.nome, a.valor])[this.value][0];
                },
            },
        },
        title: { text: '' },
        series: [{ colorByPoint: true, data: data.diretorias ? data.diretorias.map((a: any) => [a.nome, a.valor]) : [] }],
    };
    const optionsAreas: Highcharts.Options = {
        chart: { type: 'column' },
        legend: { enabled: false },
        yAxis: { min: 0, title: { text: '' } },
        tooltip: { pointFormat: '<b>R$ {point.y:,.2f}</b>' },
        colors: [
            '#fc8e5b',
            '#a6ba59',
            '#d8483d',
            '#906380',
            '#e9c382',
            '#39a693',
            '#37889b',
            '#9f8141',
            '#7a9970',
            '#fc5856',
        ],
        xAxis: {
            tickInterval: 0,
            labels: {
                enabled: true,
                formatter: function () {
                    return data.areas.map((a: any) => [a.nome, a.valor])[this.value][0];
                },
            },
        },
        title: { text: '' },
        series: [{ colorByPoint: true, data: data.areas ? data.areas.map((a: any) => [a.nome, a.valor]) : [] }],
    };
    const handleFilter = (values: Filter) => {
        getDashboardData(values).then(resp => {
            setData(resp);
        });
    };

    const optionsDepartamento: Highcharts.Options = {
        chart: { type: 'column' },
        legend: { enabled: false },
        yAxis: { min: 0, title: { text: '' } },
        tooltip: { pointFormat: '<b>R$ {point.y:,.2f}</b>' },
        colors: [
            '#fc8e5b',
            '#a6ba59',
            '#d8483d',
            '#906380',
            '#e9c382',
            '#39a693',
            '#37889b',
            '#9f8141',
            '#7a9970',
            '#fc5856',
        ],
        xAxis: {
            tickInterval: 0,
            labels: {
                enabled: true,
                formatter: function () {
                    return data.departamento.map((a: any) => [a.nome, a.valor])[this.value][0];
                },
            },
        },
        title: { text: '' },
        series: [{ colorByPoint: true, data: data.departamento ? data.departamento.map((a: any) => [a.nome, a.valor]) : [] }],
    };

    const optionsContratoVigencia: Highcharts.Options = {
        chart: { type: 'column' },
        legend: { enabled: false },
        yAxis: { min: 0, title: { text: '' } },
        tooltip: { pointFormat: '<b>Total de contratos {point.y}</b>' },
        colors: [
            "#989897",
            '#d8483d',
            '#e9c382',
            '#fc8e5b',
            '#a6ba59',
            '#37889b',
        ],
        xAxis: {
            tickInterval: 0,
            labels: {
                enabled: true,
                formatter: function () {
                    return data.vigenciaContrato.map((a: any) => [a.nome, a.valor])[this.value][0];
                },
            },
        },
        title: { text: '' },
        series: [{ colorByPoint: true, data: data.vigenciaContrato ? data.vigenciaContrato.map((a: any) => [a.nome, a.valor]) : [] }],
    };

    const optionsContratoSaldo: Highcharts.Options = {
        chart: { type: 'column' },
        legend: { enabled: false },
        yAxis: { min: 0, title: { text: '' } },
        tooltip: { pointFormat: '<b>Total de contratos {point.y}</b>' },
        colors: [
            "#989897",
            '#d8483d',
            '#e9c382',
            '#fc8e5b',
            '#a6ba59',
            '#37889b',
        ],
        xAxis: {
            tickInterval: 0,
            labels: {
                enabled: true,
                formatter: function () {
                    return data.saldoContrato.map((a: any) => [a.nome, a.valor])[this.value][0];
                },
            },
        },
        title: { text: '' },
        series: [{ colorByPoint: true, data: data.saldoContrato ? data.saldoContrato.map((a: any) => [a.nome, a.valor]) : [] }],
    };

    return (
        <SimpleView>
            <GridView noform>
                <FiltroDashboard onSearch={handleFilter} />
                <Widget title="Diretorias" span={4}>
                    <HighchartsReact highcharts={Highcharts} options={optionsDiretoria} />
                </Widget>
                <Widget title="Áreas" span={4}>
                    <HighchartsReact highcharts={Highcharts} options={optionsAreas} />
                </Widget>
                <Widget title="Dias para vencimento" span={4}>
                    <HighchartsReact highcharts={Highcharts} options={optionsContratoVigencia} />
                </Widget>
                <Widget title="Departamentos" span={8}>
                    <HighchartsReact highcharts={Highcharts} options={optionsDepartamento} />
                </Widget>
                <Widget title="Saldo Disponível" span={4}>
                    <HighchartsReact highcharts={Highcharts} options={optionsContratoSaldo} />
                </Widget>
                <DashboardContratoTabelaContratosVigentes dashboardData={data} />
            </GridView>
        </SimpleView>
    );
};

export default DashboardContratos;
